if ((typeof Checkout) === 'undefined') {
Checkout = {};
}
        
Checkout.generateToken = function (len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz,randomPoz+1);
    }
    return randomString;
};
    
Checkout.getReducedCart = function (cart_data){
    var miniCart = {};
    miniCart.token = Checkout.generateToken(32);
    miniCart.note = cart_data.note;
    miniCart.language = $("#language").val();
    var customer_id = $("#customer-id").val();
    var customer_email = $("#customer-email").val();
    if(customer_id != undefined && customer_email != undefined){
      miniCart.customer_attributes = {};
      miniCart.customer_attributes.store_id=customer_id;
      miniCart.customer_attributes.email=customer_email;
    }
    
    var fulfillments = JSON.parse(cart_data.attributes['fulfillments'] || "[]");
    
    miniCart.line_items_attributes = [];
    
    $.each(cart_data.items, function(i, item){
      var pInfo = {};
      pInfo.product_id = item.product_id;
      pInfo.variant_id = item.variant_id;
      pInfo.quantity = item.quantity;
      
      $.each(fulfillments, function(i, fulfillment){
        if(pInfo.variant_id==fulfillment.id){
          
          if(fulfillment['substitution']!==undefined)
            pInfo.substitution=fulfillment.substitution;
          
          if(fulfillment['comment']!==undefined)
            pInfo.comment=fulfillment.comment;
          
        }
      });
      
      miniCart.line_items_attributes.push(pInfo);
    });
    
    var extraItems=JSON.parse(cart_data.attributes['extraItems'] || "[]");
    if(extraItems && extraItems.length > 0)
      miniCart.extra_items_attributes = extraItems;
    var cart_attributes = {},
        key, name;
  $("[name*='attributes']").each(function() {
      name = $( this ).attr('name');
      key = name.substring(11, name.length - 1);
      cart_attributes[key] = $( this ).val();
  });
  miniCart.cart_attributes = JSON.stringify(cart_attributes);
  if(cart_data.basket){
miniCart.requires_shipping = false;
}
    return miniCart;
};
  
Checkout.sendData = function (data, onSuccess, OnFailure) {
var cart=Checkout.getReducedCart(data);
var params = {
      type: 'POST',
      url: 'https://api-checkout-supermarche-pa.zenhq.io/api/v1/carts',
      data: JSON.stringify({cart:cart}),
      dataType: 'json',
    contentType: 'application/json',
      success: onSuccess,
      error: OnFailure
    };
  jQuery.ajax(params);
};
  
Checkout.submit = function (onSuccess, OnFailure){
Shopify.getCart(function(data){Checkout.sendData(data, onSuccess, OnFailure);});
};
        
$('#update-cart, #update-cart-2').click(function( event ) {
  var redirectUrl = event.currentTarget.id != 'update-cart-2' ? "https://zenpay-supermarche-pa.zenhq.io/" : "https://zenpay-supermarche-pa.zenhq.io/";
  if (navigator.userAgent.match(/Trident\/7\./)) {
  alert("This action is not supported by Internet Explorer. Please complete your order using browsers like Firefox or Chrome");
  } else {
    Checkout.submit(
      function success(response){
          event.preventDefault();
          window.location.href = redirectUrl + response.token + "/customer";
      },
      function failure(error){
        console.log(error);
        $('#cartform').unbind('submit');
      }
    );
  }
  event.preventDefault();
});

$("#covid-form").submit(function(e){
var data = {},
    itemsData,
    items = $('#covid-form :input[type="number"]');
data.items = [];
data.attributes = {};
data.basket = true;
items.each(function() {    
  if ($(this).val() > 0) {
    itemsData = {}
    itemsData['variant_id'] = $(this).attr("data-variant-id");
    itemsData['product_id'] = $(this).attr("data-product-id");
    itemsData['quantity'] = $(this).val();
    data.items.push(itemsData);
  } 
});
if(data.items.length == 0) return false;
Checkout.sendData(
  data,
  function success(response){
    event.preventDefault();
      window.location.href = "https://zenpay-supermarche-pa.zenhq.io/" + response.token + "/customer";
  },
  function failure(error){
    $('#covid-form').unbind('submit');
  }
);
return false;
}); 

addToCart = function(value) {
jQuery.post('/cart/add.js', {items: [{quantity: 1, id: value}]}, "json").always(function(){location.reload();});
}

